<template>
  <div class="layout-main">
    <el-container>
      <el-header height="60px">
        <div class="layout-top">
          <el-row>
            <el-col :span="6">
              <div class="layout-top-item layout-logo">
              <el-row>
                  <el-col :span="5"><el-image class="layout-system-logo-image" :src="systemLogoUrl" :fit="'contain'"></el-image></el-col>
                  <el-col :span="19"><div class="layout-system-logo-text">洛江两违卫星遥感综合监测</div></el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="11"><div class="layout-top-item layout-menu">
              <el-row>
                <el-col v-for="menu in menus" :key="menu.name"  :span="3"><router-link :to="menu.path"><div :class="'layout-menu-item ' + ($route.path.indexOf(menu.path) != -1?'top-menu-item-selected': '')"><i :class="menu.icon"></i><span>{{menu.title}}</span></div></router-link></el-col>
<!--                <el-col :span="4"><router-link to="/home"><div class="layout-menu-item"><i class="el-icon-edit"></i><span>首页</span></div></router-link></el-col>
                <el-col :span="4"><router-link to="/search"><div class="layout-menu-item"><i class="el-icon-edit"></i><span>数据查询</span></div></router-link></el-col>
                <el-col :span="4"><router-link to="/fill"><div class="layout-menu-item"><i class="el-icon-edit"></i><span>数据填报</span></div></router-link></el-col>
                <el-col :span="4"><router-link to="/farm"><div class="layout-menu-item"><i class="el-icon-edit"></i><span>农场管理</span></div></router-link></el-col>
                <el-col :span="4"><router-link to="/user"><div class="layout-menu-item"><i class="el-icon-edit"></i><span>权限管理</span></div></router-link></el-col>-->
              </el-row>
            </div></el-col>
            <el-col :span="1"><div class="layout-top-item layout-msg" ref="msgRefs">
              <div>
              </div>
            </div></el-col>
            <el-col :span="4"><div class="layout-top-item layout-time"><span>{{showtime}}</span></div></el-col>
            <el-col :span="2"><div class="layout-top-item layout-mine">
              <el-dropdown>
                <div class="avatar-wrapper">
                  <el-button type="text" icon="el-icon-user-solid" slot="reference">{{userInfo.nickname}}</el-button>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item divided @click.native="changepasswordDialogVisible = true">
                    <span>修改密码</span>
                  </el-dropdown-item>
                  <el-dropdown-item divided @click.native="logout">
                    <span>退出登录</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!--<div class="layout-mine-btn" @click="logout">
              &lt;!&ndash;<el-image class="layout-mine-image"
                        :src="mineImageUrl"
                        fit="contain"></el-image>&ndash;&gt;
              <span>退出登录</span></div>
              <div style="float: right;" :title="userInfo.username" @click="handleUpdatPassWord">{{userInfo.nickname}}，</div>-->
            </div>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
    <div style="position: fixed; right: 10px; bottom: 10px; font-size: 12px; z-index: 999; text-shadow: 1px 1px 1px white">
      技术支持:北京深蓝空间遥感技术有限公司
    </div>

    <el-dialog title="修改密码" :visible.sync="changepasswordDialogVisible" :destroy-on-close="true" style="margin: auto; width: 50%">
      <changePassword v-if="changepasswordDialogVisible" :home="this" :username="userInfo.username"></changePassword>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import changePassword from '../manage/components/changePassword'
export default {
  name: 'index',
  components: {
    changePassword
  },
  data () {
    return {
      showtime: '',
      systemLogoUrl: require('@/assets/images/logo.png'),
      // mineImageUrl: require('@/assets/logo.png'),
      nowTimes: '',
      menus: [],
      userInfo: {},
      changepasswordDialogVisible: false
    }
  },
  computed: {
    ...mapGetters([
      'routers'
    ]),
    routes () {
      // return this.$router.options.routes
      return this.routers
    }
  },
  methods: {
    // 修改用户密码
    handleUpdatPassWord (username) {
      this.changepasswordDialogVisible = true
    },

    // 显示当前时间
    timeFormate () {
      const time = new Date()
      let year = time.getFullYear()
      let month =
        time.getMonth() + 1 < 10
          ? '0' + (time.getMonth() + 1)
          : time.getMonth() + 1
      let date =
        time.getDate() < 10
          ? '0' + time.getDate()
          : time.getDate()
      let hh =
        time.getHours() < 10
          ? '0' + time.getHours()
          : time.getHours()
      let mm =
        time.getMinutes() < 10
          ? '0' + time.getMinutes()
          : time.getMinutes()
      let ss =
        time.getSeconds() < 10
          ? '0' + time.getSeconds()
          : time.getSeconds()
      let week = time.getDay()
      let weeks = ['日', '一', '二', '三', '四', '五', '六']
      let getWeek = '星期' + weeks[week]
      this.showtime =
        year +
        '年' +
        month +
        '月' +
        date +
        '日' +
        ' ' +
        hh +
        ':' +
        mm +
        ':' +
        ss +
        ' ' +
        getWeek
    },
    logout () {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    showTimes () {
      this.nowTimes = setInterval(this.timeFormate, 1000)
    },
    searchMenuByRole () {
      this.menus = []
      this.routers.forEach((item, index) => {
        if (item.path === '/') {
          item.children.forEach((menu, index) => {
            this.menus.push({name: menu.name, path: '/' + menu.path, title: menu.meta.title, icon: menu.meta.icon})
          })
        }
      })
    },
    // 顶部创建一条消息
    createMsg () {
      let _this = this
      let p = document.createElement('p')
      p.style.position = 'absolute'
      p.innerHTML = '按时缴费ISO阿福撒化肥撒飞洒发哈撒火凤凰撒化肥沙发和撒火凤凰撒谎飞洒发哈市'
      let width = this.$refs.msgRefs.clientWidth
      p.style.left = width + 'px'
      p.style.color = 'white'
      p.style.zIndex = '100'
      p.style.whiteSpace = 'nowrap'
      p.style.top = 0 + 'px'
      this.$refs.msgRefs.appendChild(p)
      let x = setInterval(function () {
        p.style.left = parseInt(p.style.left) - 10 + 'px'
        if ((parseInt(p.style.right)) <= 0) {
          _this.$refs.msgRefs.removeChild(p)
          clearInterval(x)
        }
      }, 100)
    },
    clear () {
      clearInterval(this.nowTimes)
      this.showtime = null
    }
  },
  created () {
    this.showTimes()
  },
  beforeDestroy () {
    this.clear()
  },
  mounted () {
    this.searchMenuByRole()
    this.$store.dispatch('GetInfo').then((response) => {
      this.userInfo = response.data
    })
  }
}
</script>

<style scoped>
  /* layout背景 */
  .layout-main{
    height: 100%;
    width: 100%;
  }
  /* Layout顶部栏 */
  .layout-top{
    height: 60px;
    width: 100%;
    /*background: #252525;*/
    display: flex;
    overflow: hidden;
  }

  a {
    text-decoration: none;
  }

  .router-link-active {
    text-decoration: none;
  }

  .el-container{
    height: 100%;
  }

  .el-main{
    padding: 0px;
    /*background-color: rgb(51, 51, 51);*/
    min-width: 800px;
  }

  .el-header{
    /*background-color: #B3C0D1;*/
    /*color: #333;*/
    border-bottom: 1px solid #CCC;
    text-align: center;
    line-height: 60px;
    padding: 0px;
  }

  /* 系统图片 */
  .layout-system-logo-image{
    /*width: 150px;*/
    height: 40px;
    margin-top: 11px;
    border-radius: 15px;
  }

  .layout-menu-item{
    width: 100%;
    height: 100%;
    position: relative;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
    color: #000;
    opacity: 0.8;
  }

  .layout-menu-item span{

  }

  .layout-menu-item:hover{
    background: #9BAEC8;
    /*color: #333333;*/
  }

  .el-row{
    width: 100%;
    height: 100%;
  }

  .el-col{
    height: 100%;
  }

  .layout-top-item{
    height: 60px;
    width: 100%;
  }

    /* 顶部系统logo和名称 */
  .layout-logo{
    /*color: #FFFFFF;*/
  }

  /* 顶部系统菜单栏 */
  .layout-menu{
  }

  /* 顶部系统消息栏 */
  .layout-msg{
    position: relative;
    overflow: hidden;
  }

  /* 顶部时间栏 */
  .layout-time{
    text-align: center;
  }

  .layout-time span{
    /*color: #FFFFFF;*/
    font-size: 15px;
  }
  /* 顶部登录信息栏 */
  .layout-mine{
  }

  /* 退出登录按钮 */
  .layout-mine-btn{
    height: 50px;
    width: 80px;
    position: relative;
    cursor:pointer;
    text-align: left;
    float: right;
    opacity: 0.8;
  }

  .layout-mine-image{
    width: 20px;
    height: 20px;
    border-radius: 15px;
    position: absolute;
    left: 14px;
    top: 15px;
  }
  .layout-mine-btn span{
    /*color: #FFFFFF;*/
    position: absolute;
    /*left: 40px;*/
  }
  .layout-mine-btn:hover{
    color: #9BAEC8;
    font-weight: bolder;
    opacity: 1;
  }
  .top-menu-item-selected{
    background: #9BAEC8;
    color: #333333;
  }
  .layout-system-logo-text{
    text-align: left;
    text-indent: 15px;
    font-size: 24px;
    /*font-weight: bold;*/
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue